export default __webpack_public_path__ + "static/media/reactjs.14637f58.svg";